export default __webpack_public_path__ + "static/media/entry-menu.8f0e3095.jpeg";